export default "__VITE_ASSET__Bni73YEL__"